import {
  Card,
  Heading,
  IconMail,
  IconPhone,
  Stack,
  Text,
  TextLink,
  TextLinkButton,
} from 'braid-design-system';
import { DateTime } from 'luxon';
import { useEffect, useRef, useState } from 'react';

import * as styles from './Enquiry.css';

interface Props {
  enquiry: {
    userId: string;
    enquiryId: string;
    listingId: string;
    name: string;
    emailAddress: string;
    message: string;
    phoneCountryCode: string | null;
    phoneNumber: string | null;
    lastUpdated: string;
  };
}

const Enquiry = ({ enquiry }: Props) => {
  const [shouldTruncateText, setShouldTruncateText] = useState(false);
  const [showFullMessage, setShowFullMessage] = useState(false);

  const messageTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messageTextRef && messageTextRef.current) {
      setShouldTruncateText(
        messageTextRef.current.offsetHeight <
          messageTextRef.current.scrollHeight ||
          messageTextRef.current.offsetWidth <
            messageTextRef.current.scrollWidth,
      );
    }
  }, []);

  const emailHref = `mailto:${enquiry.emailAddress}?subject=Regarding your enquiry on SEEK Business`;
  const phoneHref = `tel:+${enquiry.phoneCountryCode}${enquiry.phoneNumber}`;

  return (
    <Card component="section">
      <Stack space="large">
        <Heading level="4">{enquiry.name}</Heading>

        <Stack space="small">
          <Text size="small" icon={<IconPhone />}>
            {enquiry.phoneNumber && enquiry.phoneCountryCode ? (
              <TextLink href={phoneHref}>
                +{enquiry.phoneCountryCode} {enquiry.phoneNumber}
              </TextLink>
            ) : (
              'Phone number not provided'
            )}
          </Text>

          <Text size="small" icon={<IconMail />}>
            <TextLink href={emailHref}>{enquiry.emailAddress}</TextLink>
          </Text>
        </Stack>

        <Text tone="secondary" size="small">
          Recieved{' '}
          {DateTime.fromISO(enquiry.lastUpdated).toFormat('dd MMM yyyy')}
        </Text>

        <Stack space="small">
          <Text>
            <div
              className={!showFullMessage ? styles.lineClamp : undefined}
              ref={messageTextRef}
            >
              {enquiry.message}
            </div>
          </Text>

          {shouldTruncateText && (
            <Text>
              <TextLinkButton
                onClick={() => setShowFullMessage(!showFullMessage)}
              >
                {showFullMessage ? 'Show Less' : 'Show More...'}
              </TextLinkButton>
            </Text>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default Enquiry;
